export default "__VITE_ASSET__BrkBQ0UO__"